import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/purchasedTimesSRP/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showPurchasedTimesSRPSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showPurchasedTimesSRPSelector };
